module.exports = __webpack_public_path__ + "src/img/defaultAvatar.295cfb77.png";